import {Component, inject, model, OnDestroy, OnInit} from '@angular/core';
import {EventTrackerService} from "../../services/event-tracker.service";
import {firstValueFrom, Subject} from "rxjs";
import {ActivatedRoute, Router} from "@angular/router";
import {AnalysisService} from "../../services/analysis.service";

@Component({
    selector: 'app-dialog-cancel',
    templateUrl: './dialog-cancel.component.html',
    styleUrls: ['./dialog-cancel.component.scss'],
    standalone: false
})
export class DialogCancelComponent implements OnInit, OnDestroy {

  protected tracker = inject(EventTrackerService);
  protected analysisService = inject(AnalysisService);
  protected router = inject(Router);
  protected route = inject(ActivatedRoute);

  dialogDisplay = model.required<boolean>();

  protected readonly onDestroy$ = new Subject();

  ngOnInit(): void {
    this.tracker.trackEvent('Dialog', 'Cancel', 'show');
  }
  ngOnDestroy(): void {
    this.tracker.trackEvent('Dialog', 'Cancel', 'hide');
    this.onDestroy$.next(true);
    this.onDestroy$.complete();
  }

  async onCloseDialog(_continue: boolean) {
    this.dialogDisplay.set(false);

    if (_continue) {
      const analysis = await firstValueFrom(this.analysisService.abortAnalysis());
      await this.router.navigate([analysis ? '../photoshoot' : '../license'], {relativeTo: this.route, queryParams: {nocheck: true}});
    }
  }

}
